var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath193(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.895,
    height: 172.437,
    viewBox: "0 0 104.895 172.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1611.787,1148.355l-.638.905-14.486,20.505L1565.406,1214l-14.475,20.494-8.339,11.807a3.772,3.772,0,0,1-6.727-3.144l2.32-8.663,5.486-20.494,7.574-28.253A3.766,3.766,0,0,0,1547.6,1181H1511.37a3.775,3.775,0,0,1-3.085-5.95l3.734-5.289,14.487-20.505,31.245-44.236,14.475-20.494,5.254-7.434a3.774,3.774,0,0,1,6.727,3.155l-1.149,4.279-5.486,20.494-8.745,32.638a3.765,3.765,0,0,0,3.642,4.743H1608.7a3.773,3.773,0,0,1,3.085,5.95",
    transform: "translate(-1507.588 -1075.483)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath193);
export default __webpack_public_path__ + "static/media/Path 193.8514df64a1c8b2e19e94e3567926ff9b.svg";
export { ForwardRef as ReactComponent };